// extracted by mini-css-extract-plugin
export var book = "styles-module--book--c66b9";
export var group = "styles-module--group--df58c";
export var link = "styles-module--link--16a70";
export var links = "styles-module--links--87412";
export var nav = "styles-module--nav--82fe6";